"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function FeaturedCaseStudy() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  const [parallaxY, setParallaxY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const rect = parallaxRef.current.getBoundingClientRect();
        const scrollProgress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        setParallaxY(scrollProgress * 30);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={parallaxRef} className="relative py-16 md:py-24 bg-background overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {}
          <div ref={leftRef} className="relative" style={{
          transform: `translateY(${parallaxY}px)`,
          opacity: leftVisible ? 1 : 0,
          transition: "opacity 150ms ease-out, transform 150ms ease-out"
        }}>
            <div className="relative aspect-[4/3] w-full rounded-lg overflow-hidden shadow-medium">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517610/img/restaurant_interior_dining_area.png" alt="Featured restaurant interior showcasing successful campaign results" className="w-full h-full object-cover" />
            </div>
          </div>

          {}
          <div ref={rightRef} className="flex flex-col gap-6" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateX(0)" : "translateX(2rem)",
          transition: "opacity 150ms ease-out, transform 150ms ease-out"
        }}>
            <div className="flex flex-col gap-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground leading-tight">
                The Gourmet Bistro Success Story
              </h2>
              
              <div className="flex items-baseline gap-3">
                <span className="text-5xl md:text-6xl font-display font-bold text-primary">
                  +30%
                </span>
                <span className="text-xl md:text-2xl text-muted-foreground font-medium">
                  repeat visits
                </span>
              </div>

              <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-xl">
                Through targeted email campaigns and strategic list building, we helped The Gourmet Bistro transform their customer engagement and drive measurable revenue growth.
              </p>
            </div>

            <div className="flex flex-wrap gap-4 items-center">
              <Link to="/SuccessStoriesPage">
                <Button size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground shadow-xs h-10 rounded-md px-6 has-[>svg]:px-4 transition-all duration-[80ms] ease-in-out !bg-[hsl(213,94%,68%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 hover:scale-102 hover:shadow-medium">
                  View Full Case Study
                </Button>
              </Link>
              
              <Link to="/ContactPage">
                <Button variant="outline" size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive border shadow-xs h-10 rounded-md px-6 has-[>svg]:px-4 transition-all duration-[80ms] ease-in-out !bg-[hsl(213,94%,68%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:scale-102">
                  Start Your Success Story
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}